import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class SiiSearchService {

    constructor() { }
    showSearchModal(
        title: string = "Buscando en el SII",
        text: string = "Estamos buscando información de la empresa en el SII. Esto puede tardar unos segundos"
    ): Subject<void> {
        const cancelSubject = new Subject<void>();
        
         Swal.fire({
            imageUrl: './assets/deployAssets/icons/loader_16x16.gif',
            imageWidth: 19,
            imageHeight: 19,
            title: title,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            cancelButtonColor: "red",
            allowOutsideClick: false,
            allowEscapeKey: false,
            text: text,
        }).then((result) => {
            if (result.isDismissed && String(result.dismiss) === "cancel") {
                cancelSubject.next();
            }
            cancelSubject.complete();
        });
        setTimeout(() => {
            if (Swal.isVisible() && Swal.getTitle()?.textContent === title) {
                Swal.update({
                    title: title,
                    text: "La búsqueda está tomando más tiempo de lo esperado. Es posible que el SII tenga alguna sobrecarga. Unos segundos más por favor",
                });
            }
        }, 30 * 1000);

        return cancelSubject;
    }
    showResolutionSearchModal(): Subject<void> {
        return this.showSearchModal(
            "Buscando en el SII",
            "Estamos buscando los datos de resolución en el SII. Esto puede tardar unos segundos"
        );
    }
    showCompanySearchModal(): Subject<void> {
        return this.showSearchModal(
            "Buscando en el SII",
            "Estamos buscando información de la empresa en el SII. Esto puede tardar unos segundos"
        );
    }

    closeSearchModal(): void {
        Swal.close();
    }
    showSuccessMessage(message: string, timer: number = 2000): void {
        Swal.fire({
            icon: 'success',
            title: 'Datos encontrados',
            text: message,
            timer: timer,
            showConfirmButton: false
        });
    }

    showNoDataMessage(message: string): void {
        Swal.fire({
            icon: 'info',
            title: 'Sin datos en el SII',
            text: message,
            confirmButtonText: 'Entendido'
        });
    }

    showErrorMessage(message: string): void {
        Swal.fire({
            icon: 'warning',
            title: 'Error en la búsqueda',
            text: message,
            confirmButtonText: 'Entendido'
        });
    }
}